<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8>
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{ isMyProfile ? "Mi perfil" : "Perfil" }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card v-if="loading">
              <v-container fluid fill-height>
                <v-layout align-center justify-center>
                  <v-card-text>
                    Cargando...
                    <v-progress-linear
                      indeterminate
                      color="blue"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-card>
            <v-card v-if="notfound">
              <v-alert :value="true" type="error" color="red">
                Perfil no encontrado.
              </v-alert>
            </v-card>
            <v-card v-if="!loading && !notfound">
              <v-card-text>
                <v-list three-line>
                  <v-list-tile avatar>
                    <v-list-tile-avatar
                      size="100"
                      color="grey lighten-3"
                      class="mr-3"
                    >
                      <v-avatar size="100" color="grey lighten-4">
                        <img
                            id="photo"
                            :src="userPhoto"
                            alt="avatar"
                        />
                      </v-avatar>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ username }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        Registrado desde {{ mostrarFecha(dateSignUp) }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title v-if="isMyProfile">
                        Último acceso el {{ mostrarFecha(dateLastLogIn) }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-tooltip
                      v-if="!emailVerified"
                      visibility="hidden"
                      color="red"
                      bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon color="red" dark v-on="on">email</v-icon>
                      </template>
                      <span>Email no verificado</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="isMyProfile">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          to="/config"
                          v-on="on"
                        >
                          <v-icon>settings</v-icon>
                        </v-btn>
                      </template>
                      <span>Ajustes</span>
                    </v-tooltip>
                  </v-list-tile>
                </v-list>
                <v-divider />
                <v-subheader>Descripción</v-subheader>
                <v-textarea
                  solo
                  flat
                  readonly
                  auto-grow
                  name="input-7-4"
                  label="Sin descripción"
                  :value="description"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}
export const db = firebaseApp.database();

//Perfil de un usuario
// @group Descripciones
export default {
  data() {
    return {
      loading: true,
      notfound: false
    };
  },
  created() {
    this.$bindAsArray(
      "arrayDatos",
      db
        .ref("users")
        .orderByChild("uid")
        .equalTo(this.getUid)
        .limitToFirst(1),
      snap => {
        if (this.arrayDatos.length === 0) {
          this.notfound = true;
        }
        this.loading = false;
      },
      error => {
        if (this.arrayDatos.length === 0) {
          this.notfound = true;
        }
        this.loading = false;
      }
    );
  },
  methods: {
    // @vuese
    // Procesa un objeto date y lo muestra formateado
    // @arg Fecha
    mostrarFecha(fecha) {
      let dateStr = JSON.parse('"' + fecha + '"');
      let date = new Date(dateStr);
      return date.toLocaleString("es-ES");
    }
  },
  computed: {
    // @vuese
    // Devuelve el parámetro ID del navegador
    getIDParameter() {
      return this.$route.query.id;
    },
    // @vuese
    // Indica si el parámetro ID del navegador existe
    parameterIDExists() {
      if (this.$route.query.id === undefined || this.$route.query.id === null) {
        return false;
      } else {
        return true;
      }
    },
    // @vuese
    // Indica si se está visitando un perfil ajeno
    isMyProfile() {
      if (
        (this.parameterIDExists && this.getIDParameter === this.$store.state.user.uid) ||
        !this.parameterIDExists
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Devuelve el nombre del usuario
    name() {
      if (this.arrayDatos[0] === null || this.arrayDatos[0] === undefined) {
        return "name";
      } else {
        return this.arrayDatos[0].name;
      }
    },
    // @vuese
    // Devuelve el nombre de usuario
    username() {
      if (this.arrayDatos[0] === null || this.arrayDatos[0] === undefined) {
        return "username";
      } else {
        return this.arrayDatos[0].username;
      }
    },
    // @vuese
    // Devuelve el email del usuario
    email() {
      return this.$store.state.user.email;
    },
    // @vuese
    // Indica si el usuario tiene el email verificado
    emailVerified() {
      return this.$store.state.user.emailVerified;
    },
    // @vuese
    // Devuelve la fecha de registro del usuario
    dateSignUp() {
      if (this.arrayDatos[0] === null || this.arrayDatos[0] === undefined) {
        return "dateSignUp";
      } else {
        return this.arrayDatos[0].dateSignUp;
      }
    },
    // @vuese
    // Devuelve la fecha de último inicio de sesión del usuario
    dateLastLogIn() {
      if (this.arrayDatos[0] === null || this.arrayDatos[0] === undefined) {
        return "dateLastLogIn";
      } else {
        return this.arrayDatos[0].dateLastLogIn;
      }
    },
    // @vuese
    // Devuelve la descripción del usuario
    description() {
      if (this.arrayDatos[0] === null || this.arrayDatos[0] === undefined) {
        return "Sin descripción";
      } else {
        return this.arrayDatos[0].description;
      }
    },
    // @vuese
    // Extrae la foto del usuario
    userPhoto() {
      if (
        this.arrayDatos[0] === null ||
        this.arrayDatos[0] === undefined ||
        this.arrayDatos[0].photo === null ||
        this.arrayDatos[0].photo === undefined
      ) {
        return "/img/user.svg";
      } else {
        return this.arrayDatos[0].photo;
      }
    },
    // @vuese
    // Devuelve el ID del usuario
    getUid() {
      if (this.parameterIDExists) {
        return this.getIDParameter;
      } else {
        return this.$store.state.user.uid;
      }
    }
  }
};
</script>
